export const getCyclicColor = (index: number): string => {
    const colors = ['bg-blue', 'bg-pink', 'bg-warning', 'bg-purple'];
    const colorIndex = index % colors.length;
    return colors[colorIndex];
};